import { apiClient } from "./client";

/**
 * Set the signed-in professional's profile photo. `s3Key` comes from a prior
 * uploadFile(file, "avatar") call. Returns { avatarUrl, avatarDownloadUrl }.
 */
export async function setProfessionalAvatar(s3Key) {
  const res = await apiClient.put("/professional/avatar", { s3Key });
  return res.data;
}

/** Remove the signed-in professional's profile photo. */
export async function removeProfessionalAvatar() {
  const res = await apiClient.delete("/professional/avatar");
  return res.data;
}

/** Update the signed-in professional's location (city, state). */
export async function updateProfessionalLocation(location) {
  const res = await apiClient.patch("/professional/location", { location });
  return res.data;
}

/** Update the signed-in professional's skills (up to 30 skills). */
export async function updateProfessionalSkills(skills) {
  const res = await apiClient.put("/professional/skills", { skills });
  return res.data;
}
